import React, { memo, useState, useCallback } from 'react';
import { BANNER_TYPES } from '../../constants/banner.js';
import { YANDEX } from '../../constants/yandex.js';
import { useOutOfPageBanner } from '../../hooks/outOfPage.js';
import { AdFox } from '../AdFox/index.js';
import { normalizeBannerFromService } from './normalizeBannerFromService.js';

const Banner = memo(({ className, type, banner: bannersFromProps, onError, onClick, ...rest }) => {
    const banners = Array.isArray(bannersFromProps) ? bannersFromProps : [bannersFromProps];
    const wrapper = useOutOfPageBanner({
        isOutOfPage: type === BANNER_TYPES.OUT_OF_PAGE,
        onClick,
        className,
    });
    const [bannerNumber, setBannerNumber] = useState(0);
    const banner = bannerNumber > -1 ? banners[bannerNumber] : null;
    const handleError = useCallback((message) => {
        console.error(message);
        setBannerNumber((prev) => prev + 1);
    }, []);
    if (bannerNumber === -1) {
        onError && onError(bannersFromProps);
        return null;
    }
    if (!banner) {
        onError && onError(bannersFromProps);
        return null;
    }
    const isValidBanner = banner.source === YANDEX;
    if (!isValidBanner) {
        handleError(`Not valid banner ${JSON.stringify(banner)}`);
        return null;
    }
    const normalizedBanner = normalizeBannerFromService(banner);
    return (React.createElement(React.Fragment, null,
        React.createElement(AdFox, { banner: normalizedBanner, className: className, type: type, onError: handleError, onClick: onClick, ...rest }),
        wrapper));
});
Banner.displayName = 'Banner';

export { Banner };
//# sourceMappingURL=Banner.js.map
